
import "/app/src/components/Layout/SiderResizeHandle.module.less?modules";
export default {"hitBox": `hitBox-XAPFCGKj`,"dragMask": `dragMask-sxqeAALv`,"dragging": `dragging-OCTGomwh`}
